const getters = {
    marketingleads: (state) => state.marketingleads,
    marketingleadid: (state) => state.marketingleadid,
    loading: (state) => state.loading,
   
};

export default getters;